import { HttpContextToken } from "@angular/common/http";

export class Constants {


  public static MSG_SUCCESS = "Acción realizada correctamente";
  public static MSG_DANGER = "Error al realizar la acción";
  public static SPINNER = new HttpContextToken(() => true);
  public static REDIRECT = new HttpContextToken(() => true);
    
}